import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import AdminLayout from 'layouts/Admin.js';
import MainAccountLayout from 'layouts/MainAccount.js';
import { userSelector } from 'slices/userSlice';
import { useSelector } from 'react-redux';
import Api from './services/api';
import InterviewInvite from 'views/interview-invite';
import DashboardAdmin from 'views/Dashboard';
import DashboardMainAccount from 'views-main-account/Dashboard';
import DashboardInterpreter from 'views-interpreters/Dashboard';
import DashboardVendor from 'views-vendors/Dashboard';
import InterpreterLayout from 'layouts/InterpreterLayout';
import VendorLayout from 'layouts/VendorLayout';

export const ProtectedRoutes = () => {
    const { isAuthenticated, user } = useSelector(userSelector);
    Api.setClientToken(user?.token);
    return (
        <>
            <Routes>
                {/* Agar user authenticated nahi hai, toh unhe login page pe redirect kar do */}
                {!isAuthenticated && (
                    <Route path="*" element={<Navigate to="/login" replace />} />
                )}


                {/* Authenticated Users */}
                {isAuthenticated && (
                    <>
                        {/* Admin User Routing */}
                        {['admin', 'super_admin', 'subuser', 'staff_agent'].includes(user.role) && (
                            <>
                                <Route path="/*" element={<AdminLayout />} />
                                <Route path="/*dashboard" element={<DashboardAdmin />} />
                                <Route path="/interview-invite" element={<InterviewInvite />} />
                                <Route path="/*" element={<Navigate to="/dashboard" replace />} />
                            </>
                        )}

                        {/* Main Account User Routing */}
                        {user.role === 'main_account' && (
                            <>
                                <Route path="/user/*" element={<MainAccountLayout />} />
                                <Route path="/user/*dashboard" element={<DashboardMainAccount />} />
                                <Route path="/user/interview-invite" element={<InterviewInvite />} />
                                <Route path="/" element={<Navigate to="/user/dashboard" replace />} />
                                <Route path="/dashboard" element={<Navigate to="/user/dashboard" replace />} />

                            </>
                        )}

                        {user.role === 'staff_interpreter' && (
                            <>
                                <Route path="/interpreter/*" element={<InterpreterLayout />} />
                                <Route path="/interpreter/*dashboard" element={<DashboardInterpreter />} />
                                <Route path="/" element={<Navigate to="/interpreter/dashboard" replace />} />
                                <Route path="/dashboard" element={<Navigate to="/interpreter/dashboard" replace />} />
                            </>
                        )}

                        {user.role === 'vendor' && (
                            <>
                                <Route path="/vendor/*" element={<VendorLayout />} />
                                <Route path="/vendor/*dashboard" element={<DashboardVendor />} />
                                <Route path="/" element={<Navigate to="/vendor/dashboard" replace />} />
                                <Route path="/dashboard" element={<Navigate to="/vendor/dashboard" replace />} />
                            </>
                        )}
                    </>
                )}

                {/* Default redirects */}
                <Route path="/login" element={<Navigate to={!isAuthenticated ? "/login" : "/"} replace />} />
                {/* 404 Page */}
                <Route path="*" element={<Navigate to="/404" replace />} />
            </Routes>
        </>
    );
};
